// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8341e5592963ba736f5f","655":"1615992db5cd05e4b0ab"}[chunkId] + ".js";
};